/* app/js/src/components/broadcast/take-over-confirm-dialog/take-over-confirm-dialog.component.scss */
.take-over-confirm-content {
  padding: 16px 0;
  min-width: 320px;
}
.take-over-confirm-message {
  margin: 0 0 20px 0;
  font-size: 0.9375rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
}
.take-over-confirm-actions {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: stretch;
}
.take-over-cancel-btn {
  align-self: center;
  padding: 16px 48px;
  min-width: 200px;
  min-height: 52px;
  font-size: 1.125rem;
  font-weight: 500;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}
.take-over-cancel-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}
.take-over-slider-wrap {
  width: 100%;
}
/*# sourceMappingURL=take-over-confirm-dialog.component.css.map */
